/* ==========================================================================
   AUREN ATHLEISURE, APEX TEE  (apex.js)
   Vanilla JS, no dependencies. Progressive enhancement: if anything throws,
   the native product form still posts to /cart/add.
   Handles: variant selection, the quantity-tier AOV engine, free-ship nudge,
   AJAX add-to-cart (+ order bump), sticky ATC, cross-sell quick-add, gallery,
   and the FAQ accordion.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-apex-root]');

  /* ----- money ---------------------------------------------------------- */
  var CURRENCY = (root && root.dataset.moneySymbol) || 'USD';
  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function tierTotal(price, qty, disc) { return Math.round((price * qty * (100 - disc)) / 100); }

  /* ===================================================================== *
   *  BUY BOX
   * ===================================================================== */
  if (root) buyBox(root);

  function buyBox(root) {
    var form = root.querySelector('#apex-form');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-apex-variants]').textContent); } catch (e) {}

    var idInput = root.querySelector('[data-apex-variant-id]');
    var qtyInput = root.querySelector('[data-apex-qty]');
    var packInput = root.querySelector('[data-apex-pack]');
    var priceEl = root.querySelector('[data-apex-price]');
    var compareEl = root.querySelector('[data-apex-compare]');
    var unitNote = root.querySelector('[data-apex-unit-note]');
    var addBtn = root.querySelector('[data-apex-add]');
    var addLabel = root.querySelector('[data-apex-add-label]');
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-apex-option]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-apex-tier]'));
    var offerEl = root.querySelector('[data-apex-offer]');
    var offerSavingsWord = (offerEl && offerEl.dataset.savingsWord) || 'Saved';
    var offerFreeshipLabel = (offerEl && offerEl.dataset.freeshipLabel) || '';
    var offerShowFreeship = !!(offerEl && offerEl.dataset.showFreeship === 'true');
    var offerUnitSuffix = (offerEl && offerEl.dataset.unitSuffix) || '/tee';
    var offerTotalWord = (offerEl && offerEl.dataset.totalWord) || 'total';
    var soldoutText = root.dataset.soldoutText || 'Sold out';
    var bump = root.querySelector('[data-apex-bump]');

    /* selection state: array of chosen option values by option index */
    var selection = [];
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.dataset.apexOption, 10);
      var pressed = group.querySelector('[aria-pressed="true"]');
      selection[idx] = pressed ? pressed.dataset.apexValue : (group.querySelector('[data-apex-value]') || {}).dataset?.apexValue;
    });

    var currentVariant = resolveVariant();
    var selectedTier = tiers.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0] || tiers[0];

    /* --- variant resolution --- */
    function resolveVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    /* a value at optIdx is available given the OTHER currently-selected options */
    function valueAvailable(optIdx, value) {
      return variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optIdx] !== value) return false;
        return v.options.every(function (opt, i) { return i === optIdx || opt === selection[i]; });
      });
    }

    /* --- option clicks --- */
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.dataset.apexOption, 10);
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-apex-value]');
        if (!btn || btn.dataset.soldout === 'true') return;
        selection[idx] = btn.dataset.apexValue;
        group.querySelectorAll('[data-apex-value]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var valLabel = group.querySelector('[data-apex-option-value]');
        if (valLabel) valLabel.textContent = btn.dataset.apexValue;
        onChange();
      });
    });

    /* --- tier clicks --- */
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        selectedTier = tier;
        tiers.forEach(function (t) { t.setAttribute('aria-pressed', t === tier ? 'true' : 'false'); });
        onChange();
      });
    });

    /* --- recompute everything on any change --- */
    function onChange() {
      currentVariant = resolveVariant();

      /* refresh availability + auto-correct an unavailable size */
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.dataset.apexOption, 10);
        group.querySelectorAll('[data-apex-value]').forEach(function (b) {
          var ok = valueAvailable(idx, b.dataset.apexValue);
          if (group.dataset.optionType === 'size') {
            b.dataset.soldout = ok ? 'false' : 'true';
          }
        });
        if (group.dataset.optionType === 'size' && (!currentVariant || !currentVariant.available)) {
          var firstOk = group.querySelector('[data-soldout="false"]');
          if (firstOk && firstOk.dataset.apexValue !== selection[idx]) {
            selection[idx] = firstOk.dataset.apexValue;
            group.querySelectorAll('[data-apex-value]').forEach(function (b) {
              b.setAttribute('aria-pressed', b === firstOk ? 'true' : 'false');
            });
            currentVariant = resolveVariant();
          }
        }
      });

      var price = currentVariant ? currentVariant.price : variants[0].price;

      /* price block */
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl && currentVariant && currentVariant.compare_at > price) {
        compareEl.textContent = money(currentVariant.compare_at);
      }

      /* tiers: recompute per-unit, total, savings + free shipping for the live price */
      tiers.forEach(function (tier) {
        var tq = parseInt(tier.dataset.qty, 10);
        var td = parseInt(tier.dataset.discount, 10);
        var ttotal = tierTotal(price, tq, td);
        var tunit = Math.round(ttotal / tq);
        var tsaved = price * tq - ttotal;
        var uEl = tier.querySelector('[data-apex-tier-unit]');
        var tEl = tier.querySelector('[data-apex-tier-total]');
        var sEl = tier.querySelector('[data-apex-tier-save]');
        if (uEl) uEl.innerHTML = money(tunit) + '<span>' + offerUnitSuffix + '</span>';
        if (tEl) tEl.textContent = money(ttotal) + ' ' + offerTotalWord;
        if (sEl) {
          var line = tsaved > 0 ? money(tsaved) + ' ' + offerSavingsWord : '';
          if (offerShowFreeship && offerFreeshipLabel && threshold > 0 && ttotal >= threshold) {
            line = line ? line + ' + ' + offerFreeshipLabel : offerFreeshipLabel;
          }
          sEl.textContent = line;
        }
      });

      /* selected-tier driven outputs */
      var q = selectedTier ? parseInt(selectedTier.dataset.qty, 10) : 1;
      var d = selectedTier ? parseInt(selectedTier.dataset.discount, 10) : 0;
      var sel_total = tierTotal(price, q, d);
      var saved = price * q - sel_total;

      if (qtyInput) qtyInput.value = q;
      if (currentVariant && idInput) idInput.value = currentVariant.id;
      if (packInput && selectedTier) packInput.value = selectedTier.dataset.pack || '';

      if (unitNote) {
        unitNote.textContent = q > 1
          ? q + ' tees · ' + money(sel_total) + (saved > 0 ? ', you save ' + money(saved) : '')
          : '';
      }

      /* availability / button state */
      var available = currentVariant && currentVariant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        if (addLabel) addLabel.textContent = available ? (addBtn.dataset.labelDefault || addLabel.textContent) : soldoutText;
      }

      updateShip(sel_total, available);
      updateSticky(sel_total, q, saved, available);
      scrollToVariantMedia();
    }

    /* --- free shipping nudge --- */
    var shipText = root.querySelector('[data-apex-ship-text]');
    var shipFill = root.querySelector('[data-apex-ship-fill]');
    var threshold = parseInt(root.dataset.shipThreshold, 10) || 0;
    var shipStyle = root.dataset.shipStyle || 'items';
    var shipLabel = root.dataset.shipLabel || 'Add one more to unlock free shipping';
    var shipAmountSuffix = root.dataset.shipAmountSuffix || 'away from free shipping';
    var shipUnlocked = root.dataset.shipUnlocked || 'Free shipping unlocked';
    function updateShip(total) {
      if (!shipText || !threshold) return;
      var unlocked = total >= threshold;
      shipText.classList.toggle('is-unlocked', unlocked);
      if (unlocked) {
        shipText.textContent = '✓ ' + shipUnlocked;
        if (shipFill) shipFill.style.width = '100%';
      } else {
        shipText.textContent = shipStyle === 'amount'
          ? money(threshold - total) + ' ' + shipAmountSuffix
          : shipLabel;
        if (shipFill) shipFill.style.width = Math.min(100, (total / threshold) * 100) + '%';
      }
    }

    /* --- sticky bar mirror --- */
    var stickyPrice = document.querySelector('[data-apex-sticky-price]');
    var stickyNote = document.querySelector('[data-apex-sticky-note]');
    function updateSticky(total, q, saved, available) {
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (stickyNote) stickyNote.textContent = (q > 1 && saved > 0) ? ' · save ' + money(saved) : '';
    }

    /* --- gallery sync to selected variant image --- */
    var galleryTrack = root.querySelector('[data-apex-gallery-track]');
    function scrollToVariantMedia() {
      if (!galleryTrack || !currentVariant || !currentVariant.media_id) return;
      var slide = galleryTrack.querySelector('[data-media-id="' + currentVariant.media_id + '"]');
      if (slide && galleryTrack.scrollWidth > galleryTrack.clientWidth) {
        galleryTrack.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    if (addBtn && addLabel) addBtn.dataset.labelDefault = addLabel.textContent;

    /* --- ADD TO CART (AJAX + order bump, native fallback) --- */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; /* let it post natively */
        e.preventDefault();
        if (!currentVariant || !currentVariant.available) return;
        addToCart();
      });
    }

    /* section ids the theme uses to re-render the cart drawer contents */
    function cartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
      });
      return ids.join(',');
    }

    function addToCart() {
      var q = selectedTier ? parseInt(selectedTier.dataset.qty, 10) : 1;
      var items = [{
        id: currentVariant.id,
        quantity: q,
        properties: packInput && packInput.value ? { _pack: packInput.value } : {}
      }];
      if (bump && bump.checked && bump.dataset.bumpId) {
        items.push({ id: parseInt(bump.dataset.bumpId, 10), quantity: 1 });
      }
      var body = { items: items };
      var secs = cartSectionIds();
      if (secs) body.sections = secs; /* ask Shopify to return re-rendered cart drawer HTML */
      var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) ? Theme.routes.cart_add_url : '/cart/add.js';

      setBtnLoading(true);
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (res) { afterAdd(res); })
        .catch(function () { setBtnLoading(false); if (form) form.submit(); });
    }

    function setBtnLoading(on) {
      if (!addBtn) return;
      addBtn.disabled = on;
      if (addLabel) addLabel.textContent = on ? 'Adding...' : (addBtn.dataset.labelDefault || 'Add to cart');
    }

    function afterAdd(res) {
      var mode = (root.dataset.afterAtc || 'drawer');
      if (mode === 'checkout') { window.location.href = '/checkout'; return; }
      if (mode === 'cart') { window.location.href = '/cart'; return; }
      /* drawer: announce the change so the theme re-renders the drawer + count,
         then open it. This is the theme's own pipeline, so the item shows at once. */
      notifyCartUpdated(res);
      var opened = openThemeDrawer();
      setBtnLoading(false);
      if (!opened) window.location.href = '/cart';
    }

    /* paint initial computed state */
    onChange();
  }

  /* ===================================================================== *
   *  THEME CART INTEGRATION
   * ===================================================================== */
  /* Fire the events the Auren theme (and most cart-drawer apps) listen for, so
     the drawer contents + cart count refresh with the item we just added.
     'cart:update' is the Auren theme's own event name (see events.js). */
  function notifyCartUpdated(res) {
    var detail = {
      resource: res || null,
      sourceId: 'apex-buy-box',
      data: { source: 'apex-buy-box', sections: res && res.sections }
    };
    ['cart:update', 'cart:refresh', 'cart:added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
    });
  }

  /* Open the theme's cart drawer. Auren exposes <cart-drawer-component>.open(). */
  function openThemeDrawer() {
    var themeDrawer = document.querySelector('cart-drawer-component');
    if (themeDrawer && typeof themeDrawer.open === 'function') {
      try { themeDrawer.open(); return true; } catch (e) {}
    }
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]');
    if (drawer) {
      if (typeof drawer.open === 'function') { try { drawer.open(); return true; } catch (e) {} }
      if (typeof drawer.show === 'function') { try { drawer.show(); return true; } catch (e) {} }
    }
    /* fall back to clicking the header cart icon (opens drawer, or goes to /cart) */
    var toggles = ['.header-actions__cart-icon', '#cart-icon-bubble', '[data-cart-drawer-toggle]',
      'a[href$="/cart"]', 'a[href*="/cart"]'];
    for (var i = 0; i < toggles.length; i++) {
      var el = document.querySelector(toggles[i]);
      if (el && el.click) { el.click(); return true; }
    }
    return false;
  }

  /* ===================================================================== *
   *  STICKY ADD-TO-CART
   * ===================================================================== */
  (function sticky() {
    var bar = document.querySelector('[data-apex-sticky]');
    var anchor = document.querySelector('[data-apex-add]');
    var form = document.querySelector('#apex-form');
    if (!bar || !anchor || !form) return;
    bar.hidden = false;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          /* show once the main ATC has scrolled out above the viewport */
          var below = en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(anchor);
    }

    var stickyAdd = bar.querySelector('[data-apex-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      /* scroll to the top buy box, do NOT add to cart or open the drawer */
      var top = document.getElementById('apex-top');
      if (top && top.scrollIntoView) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  /* ===================================================================== *
   *  CROSS-SELL QUICK-ADD
   * ===================================================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-apex-xadd]');
    if (!btn || !window.fetch) return; /* fall back to the link href */
    var id = btn.dataset.variantId;
    if (!id) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { btn.textContent = '✓ Added'; setTimeout(function () { window.location.href = '/cart'; }, 500); })
      .catch(function () { window.location.href = btn.getAttribute('href') || '/cart'; });
  });

  /* ===================================================================== *
   *  GALLERY DOTS
   * ===================================================================== */
  (function gallery() {
    var g = document.querySelector('[data-apex-gallery]');
    if (!g) return;
    var track = g.querySelector('[data-apex-gallery-track]');
    var dots = Array.prototype.slice.call(g.querySelectorAll('[data-apex-dot]'));
    if (!track || !dots.length) return;

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var slide = track.children[parseInt(dot.dataset.apexDot, 10)];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ===================================================================== *
   *  FAQ ACCORDION
   * ===================================================================== */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-apex-faq-q]');
    if (!q) return;
    var open = q.getAttribute('aria-expanded') === 'true';
    q.setAttribute('aria-expanded', open ? 'false' : 'true');
    var panel = q.parentElement.querySelector('[data-apex-faq-a]');
    if (panel) panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
  });

  /* ===================================================================== *
   *  IN-PAGE ANCHOR LINKS  ->  fixes "mobile scrolls down on refresh"
   *  Links such as #apex-fit / #apex-reviews otherwise leave that hash in the
   *  URL, so the browser re-jumps to that section on every refresh. We scroll
   *  smoothly on click but keep the URL clean, and strip any apex hash that is
   *  already present (a tap before this fix, a shared link, etc.).
   * ===================================================================== */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#apex"]');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
  });

  if (location.hash && location.hash.indexOf('#apex') === 0) {
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    window.scrollTo(0, 0);
  }
})();
